











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Dashboard.DashboardSensorUpdateConfig')
    
    export class DashboardSensorUpdateConfig {
        constructor( dashboardId: number, sensorId: number, config: string ) {
            
                this.dashboardId = dashboardId;
            
                this.sensorId = sensorId;
            
                this.config = config;
            
        }

        
            public dashboardId: number;
        
            public sensorId: number;
        
            public config: string;
        
    }

    export interface IDashboardSensorUpdateConfig {
        
            dashboardId: number;
        
            sensorId: number;
        
            config: string;
        
    }

    export async function dashboardSensorUpdateConfig( command: DashboardSensorUpdateConfig ): Promise<CommandResult<void>>
    export async function dashboardSensorUpdateConfig( { dashboardId, sensorId, config }: IDashboardSensorUpdateConfig ): Promise<CommandResult<void>>
    export async function dashboardSensorUpdateConfig( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof DashboardSensorUpdateConfig) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new DashboardSensorUpdateConfig( model['dashboardId'], model['sensorId'], model['config'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace DashboardSensorUpdateConfig.ExtraneousTypes {
        

        
    }

